import { FaShareSquare, FaTimes, FaWhatsappSquare } from "react-icons/fa";
import Popup from "../../common_component/component/Popup";
import { CONSULTATION_ICONS } from "../../cufront-assets/icons/Icons";
import { MdEmail, MdSms } from "react-icons/md";
import { useEffect, useState } from "react";
import CuInput from "../../all-patient/components/CuInput";
import CuButton from "../../all-patient/components/CuButton";
// import { useCreateItem } from "../../_helper/actions/mutation/items";
// import { ApiEndPoint } from "../../_helper/constant/api-types";

const SharePrescription = ({
  phone,
  sendNotification,
  isLoading,
  position = "top-right",
  iconSize,
}) => {
  const [notification, setNotification] = useState({
    isWhatsapp: false,
    isSMS: false,
    isEmail: false,
  });
  const [sendDetails, setSendDetails] = useState({});

  const handleNotificationType = (type) => {
    setNotification({
      isWhatsapp: false,
      isSMS: false,
      isEmail: false,
      [type]: true,
    });
  };

  const handleChange = (e, type) => {
    if (e.target.value.length <= 10) {
      if (type === "isWhatsapp") {
        setSendDetails({ ...sendDetails, whatsapp_phone: e.target.value });
      }
    }
  };

  const closeNotification = () => {
    setNotification({
      isWhatsapp: false,
      isSMS: false,
      isEmail: false,
    });
    // setSendDetails("");
  };

  const handleSendNotification = () => {
    // e.preventDefault();
    sendNotification(
      "draft",
      "share",
      notification,
      sendDetails,
      closeNotification
    );
  };

  return (
    <Popup
      trigger={<FaShareSquare size={iconSize} className="cursor-pointer" />}
      position={position}
      hoverable={false}
      arrow={true}
      content={
        <div className="m-4">
          {/* Close Icon */}
          <button
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            // onClick={onClose}
          >
            <FaTimes size={24} />
          </button>
          <h2 className="text-lg font-bold mb-4">Share Prescription</h2>

          {/* Whatsapp Sharing */}
          <div className="flex flex-col gap-3 mb-4">
            <div className="flex items-center gap-2">
              <FaWhatsappSquare className="text-green-600" size={24} />
              <label className="font-bold">WhatsApp</label>
            </div>
            <CuInput
              placeholder="Enter WhatsApp number"
              // value={whatsappNumber}
              onChange={(e) => handleChange(e, "isWhatsapp")}
              required
            />
            <CuButton
              className="w-full h-9 rounded border cursor-pointer flex justify-center items-center"
              onClick={handleSendNotification}
              isLoading={isLoading}
            >
              Send via WhatsApp
            </CuButton>
          </div>
        </div>
      }
    />
  );
};

export default SharePrescription;
